export default "__VITE_ASSET__1bc84d9a__"